/**
 * Created by Cris on 2018/1/25.
 */
import store from '@/store'
import api from '@/api'

var app = {

  type: function () {
    var u = navigator.userAgent;
    return {//移动终端浏览器版本信息
      mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      androidToJs: u.indexOf('androidToJs') > -1 || u.indexOf('Linux') > -1, //androidToJs终端或者uc浏览器
      iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1,
      wechat: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
      //是否web应该程序，没有头部与底部
    };
  }()
}

let callApp = {
  CallApp: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.CallApp.postMessage(param);
    } else if (app.type.androidToJs) {
      window.androidToJs.CallApp(param);
      // console.log(param);
    }
  },
  testType() {
    //  console.log(app.type)
    return app.type
  },
  getSession: function (session) {
    // console.log('原生发过来的session',session);
    return new Promise((resolve, reject) => {
      var timer = setInterval(getSessionId, 50);
      function getSessionId() {
      	 localStorage.setItem('session', session);
        if(localStorage.getItem('session')) {
          api.setSessionId(session)
          // console.log(`最新session 已经存好了${session}`)
          api.UserDetails(0).then((res)=>{
            if(res.q.s != 0) {//设置未登录状态
              store.dispatch('changeLogin', false)
            } else {//已登录状态
              store.dispatch('changeLogin', true)
            }
          })
          clearInterval(timer);
          resolve()
        }
      }
      
    })
  },

  checkOutCounter: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.checkOutCounter.postMessage(param);
    } else {
      window.androidToJs.checkOutCounter(JSON.stringify(param));
    }
  },
  //分享
  // invokeShare: function (param) {
  //   if (app.type.ios) {
  //     window.webkit.messageHandlers.invokeShare.postMessage(param);
  //   } else {
  //     window.androidToJs.invokeShare(JSON.stringify(param));
  //   }
  // },
  //联系客服
  invokeImWithHelper: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeImWithHelper.postMessage(param);
    } else {
      window.androidToJs.invokeImWithHelper(JSON.stringify(param));
    }
  },
  CashierDesk: function (param) {
    param.from = 'chxgo';
    if (app.type.ios) {
      window.webkit.messageHandlers.CashierDesk.postMessage(param);
    } else {
      window.androidToJs.CashierDesk(JSON.stringify(param));
    }
  },
  CallPage: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.CallPage.postMessage(param);
    } else {
      window.androidToJs.CallPage(JSON.stringify(param));
    }
  },
  backward: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.backward.postMessage(param);
    } else {
      window.androidToJs.backward(JSON.stringify(param));
    }
  },
  forward: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.forward.postMessage(param);
    } else {
      window.androidToJs.forward(JSON.stringify(param));
    }
  },
  //发起订单提交的界面
  invokeOrderSubmit(param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeOrderSubmit.postMessage(param);
    } else {
      window.androidToJs.invokeOrderSubmit(JSON.stringify(param));
    }
  },
  ShowTab: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.ShowTab.postMessage(param);
    } else {
      window.androidToJs.ShowTab(JSON.stringify(param));
    }
  },
  invokeCashApply: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeCashApply.postMessage(param);
    } else {
      window.androidToJs.invokeCashApply(JSON.stringify(param));
    }
  },

  invokeChooseContact: function (param) { //调用选择好友方法
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeChooseContact.postMessage(param);
    } else {
      window.androidToJs.invokeChooseContact(JSON.stringify(param));
    }
  },
  // 送給好友
  sendGift: function (param) { //送給好友
    if (app.type.ios) {
      window.webkit.messageHandlers.sendGift.postMessage(param);
    } else {
      window.androidToJs.sendGift(JSON.stringify(param));
    }
  },
  chooseContactResult: function (param) { //选择好友结果
    // console.log(param);
    // alert(param);
    //  localStorage.removeItem('session')
    localStorage.setItem('param',param);
  },

  //返回
  goBack: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.goBack.postMessage(param);
    } else {
      window.Js_Interactive.goBack();
    }
  },
  //首页进入详情
  indexToDetails: function(param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.indexToDetails.postMessage(param);
    } else {
      window.Js_Interactive.indexToDetails(JSON.stringify(param));
    }
  },
  //绑定设备
  bindingDevice: function(params) {
    if (app.type.ios) {
      window.webkit.messageHandlers.bindingDevice.postMessage(params);
    } else {
      window.Js_Interactive.bindingDevice();
    }
  },
  //原生跳H5页面
  pushToView: function(url) {
    if (app.type.ios) {
      window.webkit.messageHandlers.pushToView.postMessage(url);
    } else {
      window.Js_Interactive.pushToView(JSON.stringify(url));
    }
  },
  //按钮餐单同步
  synchronizationMenu: function(params) {
    if (app.type.ios) {
      window.webkit.messageHandlers.synchronizationMenu.postMessage(params);
    } else {
      window.Js_Interactive.synchronizationMenu();
    }
  },
  //收银台
  invokeCheckoutCounter: function(params) {
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeCheckoutCounter.postMessage(params);
    } else {
      window.Js_Interactive.invokeCheckoutCounter(JSON.stringify(params));
    }
  },
  //分享
  invokeShare: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeShare.postMessage(param);
    } else {
      window.Js_Interactive.invokeShare(JSON.stringify(param));
    }
  },
  //调底部
  setShowFooter: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.setShowFooter.postMessage(param);
    } else {
      window.Js_Interactive.setShowFooter(JSON.stringify(param));
    }
  },
  //调头部
  setShowHeader: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.setShowHeader.postMessage(param);
    } else {
      window.Js_Interactive.setShowHeader(JSON.stringify(param));
    }
  },
  //登录页面
  invokeLogout: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.invokeLogout.postMessage(param);
    } else {
      window.Js_Interactive.invokeLogout();
    }
  }, 
  //地址选择
  selectAddress: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.selectAddress.postMessage(param);
    } else {
      window.Js_Interactive.selectAddress();
    }
  }, 
  //session过期
  sessionExpired: function (param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.sessionExpired.postMessage(param);
    } else {
      window.Js_Interactive.sessionExpired();
    }
  },  

  //拿mac数据
  getMac: function (param) {
    let mac =''
    if (app.type.ios) {
      // mac = window.webkit.messageHandlers.getMac.postMessage(param);
    } else {
      mac = window.Js_Interactive.getMac();
    }
    return mac
  }, 
  //通知app刷新其他页面收藏状态
  onCollection: function(param) {
    if (app.type.ios) {
      window.webkit.messageHandlers.onCollection.postMessage(param);
    } else {
      window.Js_Interactive.onCollection();
    }
  }  
}

//原生传过来的参数
//获取高度
let setTitleBarHeight = (height)=> {
  store.commit('setNavHeight',height) 
}
//获取经纬度
let setLatlng = (latitude,longitude,city)=> {
  store.commit('setLatLog',{latitude,longitude,city}) 
  // console.log('原生传经纬度过来了',latitude,longitude,city)
  window.localStorage.setItem('latitude', latitude);
  window.localStorage.setItem('longitude', longitude);
  window.localStorage.setItem('loglatcity', city);
}
//传获取城市
let switchCity = (city,cid) => {
  store.commit('setCity',cid)
  // console.log('原生传城市来了',city,cid)
  window.localStorage.setItem('city', Number(cid));
} 
//获取收货地址 
let selectAddressResult = (address)=> {
  if(store.state.addList) {
    store.commit('setAddListAddressDetail',JSON.parse(address))
  } else {
    store.commit('setAddress',JSON.parse(address)) 
    store.dispatch('getOrderSubmit', true)
  }
}
//获取mac地址
let iosGetMac =  (address)=> {
  localStorage.setItem('macAddress',address)
}

window.setTitleBarHeight = setTitleBarHeight;
window.setLatlng = setLatlng;
window.switchCity = switchCity;
window.selectAddressResult = selectAddressResult;
window.iosGetMac = iosGetMac;

window.invokeLogout=callApp.invokeLogout;
window.CallApp = callApp.CallApp;
window.invokeShare = callApp.invokeShare;
window.CashierDesk = callApp.CashierDesk;
window.CallPage = callApp.CallPage;
window.backward = callApp.backward;
window.forward = callApp.forward;

window.invokeOrderSubmit = callApp.invokeOrderSubmit;
window.invokeImWithHelper = callApp.invokeImWithHelper;
window.invokeCashApply = callApp.invokeCashApply;


window.ShowTab = callApp.ShowTab;
//爱心充值
window.checkOutCounter = callApp.checkOutCounter;
window.invokeChooseContact = callApp.invokeChooseContact;
window.sendGift = callApp.sendGift;

//接收参数
window.chooseContactResult = callApp.chooseContactResult;
window.getSession = callApp.getSession;

export default callApp;



// WEBPACK FOOTER //
// ./src/callApp.js